<template>
  <div class="photo-and-text">
    <div class="row d-flex justify-content-center align-items-center">
      <div
        class="mb-5 col-lg-7 col-12 order-2 d-flex justify-content-center align-items-center"
        :class="{'order-lg-1': isRightPhoto}"
      >
        <div class :class="{'write-right': verticalText}">
          <h5 v-if="title">{{title}}</h5>
          <p v-html="text"></p>
        </div>
      </div>
      <div class="mb-5 col-lg-5 col-12 order-1" :class="{'order-lg-2': isRightPhoto}">
        <img class="main_content_img" :class="imgClass" :src="imgSrc" :alt="imgAlt" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhotoAndText",
  props: {
    isRightPhoto: Boolean,
    verticalText: Boolean,
    title: String,
    text: String,
    imgSrc: String,
    imgAlt: String,
    imgClass: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h5 {
  text-align: left;
  margin-bottom: 1rem;
}

.write-right {
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;
  text-align: left;
  margin-right: 15px;
  letter-spacing: 0.1rem;
}

p {
  text-align: left;
  font-size: 0.88rem;
  height: 300px;
}
img {
  width: 85%;
}
@media only screen and (min-width: 992px) {
  img {
    object-fit: cover;
    width: 280px;
    height: 210px;
  }
}
@media only screen and (min-width: 1200px) {
  img {
    width: 360px;
    height: 270px;
  }
}

img.contain {
  object-fit: contain;
}
</style>
